import { useCallback } from "react";
import { usePopupStore } from "..";

export default function useNavigateToLocation(): (id: number) => void {
    const popupStore = usePopupStore();

    return useCallback((id: number) => {
        popupStore.openLocationPopup(id);
    }, []);
}